// 反诈APP——主流程
const MainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `antiFraudAPP/index${i + 1}`,
  name: `antiFraudAPPIndex${i + 1}`,
  component: () => import(`@/views/shopping/antiFraudAPP/index${i + 1}.vue`)
}))



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 反诈APP——主流程，开始
    ...MainRoutes,

  ],
};
